import React, { useState, useEffect, useRef } from 'react';

interface SettingsBarProps {
  tokenModal: Function,
  helpModal: Function,
  importModal: Function,
  exportModal: Function
}

export const SettingsBar : React.FC<SettingsBarProps> = ({tokenModal, helpModal, importModal, exportModal}) => {

  return (
      <div className="header-settings-bar">
        <div className="header-row">
          <button onClick={() => tokenModal()}>Auth</button>
          <button onClick={() => helpModal()}>Help</button>
        </div>
        <div className="header-row">
          <button onClick={() => importModal()}>Import</button>
          <button onClick={() => exportModal()}>Export</button>
        </div>
      </div>
  )
}
